import {Brand} from '../Brand';
import {hardBase} from './hardBase';
import {HardLogo} from './HardLogo';

export const hard: Brand = {
  ...hardBase,
  assets: {
    logo: HardLogo,
  },
};
